import { memo } from "react"
import { makeStyles } from "tss-react/mui"
import { Grid } from "@mui/material"
import { StandardDialog } from "../../../../../shared/components/dialogs/StandardDialog"
import fallbackSvgUrl from "../../../../../shared/components/Formik/no-image.png"

const useStyles = makeStyles()((_theme) => ({
    dialogContainer: {
        position: "relative",
        "& >img": {
            width: "100%",
            height: "auto",
            objectFit: "cover",
        },
    },
    previewPaperSlot: {
        overflow: "hidden",
    },
    hideEdge: { display: "none" },
}))

export const defaultPreviewProductImageState = { show: false, image: "" }
export type DefaultPreviewProductImageStateType = Readonly<{ show: boolean; image: string }>

type PreviewProductImageProps = Readonly<{
    previewImage: DefaultPreviewProductImageStateType
    setPreviewImage: React.Dispatch<React.SetStateAction<DefaultPreviewProductImageStateType>>
}>

export const PreviewProductImage = memo(({ previewImage, setPreviewImage }: PreviewProductImageProps) => {
    const { classes } = useStyles()

    return (
        <>
            <StandardDialog
                open={previewImage.show}
                onClose={() => setPreviewImage(defaultPreviewProductImageState)}
                updateEdge={classes.hideEdge}
                slotProps={{
                    paper: { className: classes.previewPaperSlot },
                }}
            >
                <Grid container className={classes.dialogContainer}>
                    <img
                        src={`${previewImage.image}`}
                        alt="product image"
                        onError={() =>
                            setPreviewImage((prev) => {
                                return { ...prev, image: fallbackSvgUrl }
                            })
                        }
                    />
                </Grid>
            </StandardDialog>
        </>
    )
})
